import { Component, Menu } from '@contember/admin'
import * as React from 'react'

export const TenantMenuItem = Component(() => <Menu.Item title="Users" to="tenantUsers" />, 'TenantMenuItem')
